import { FileState } from '@/interfaces/states/file-state.interface';

const state: FileState = {
  highlights: [],
  lastUploaded: [],
  showHighlights: true,
  loading: true,
  error: {
    code: null,
    msg: null,
  },
};

export default state;
